
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("44gMI", function(module, exports) {

$parcel$export(module.exports, "useIsDropdownOpen", () => $a0d1a4c0cace8e3c$export$f23a75298e125425);
$parcel$export(module.exports, "default", () => $a0d1a4c0cace8e3c$export$2e2bcd8739ae039);
/* index-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gPt5r = parcelRequire("gPt5r");
var $gDPDy = parcelRequire("gDPDy");

var $gwIPs = parcelRequire("gwIPs");

var $lcCsd = parcelRequire("lcCsd");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $12d8n = parcelRequire("12d8n");

var $2xSAL = parcelRequire("2xSAL");

var $5EE6D = parcelRequire("5EE6D");

var $dMjRW = parcelRequire("dMjRW");

var $4W84M = parcelRequire("4W84M");

var $dRg19 = parcelRequire("dRg19");

var $8iWLt = parcelRequire("8iWLt");

var $hqPdr = parcelRequire("hqPdr");
const $a0d1a4c0cace8e3c$export$f23a75298e125425 = (isOpen = false)=>(0, $5uXOq.useState)(isOpen);
const $a0d1a4c0cace8e3c$var$CreatePullRequestDropdownInner = ({ createPullRequestTargets: createPullRequestTargets, renderDropdownTrigger: renderDropdownTrigger, onOpenDropdown: onOpenDropdown, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $a0d1a4c0cace8e3c$export$f23a75298e125425();
    const [filteredTargets, setFilteredTargets] = (0, $5uXOq.useState)(createPullRequestTargets ?? []);
    const wasOpen = (0, $1XJ20.usePreviousWithInitial)(isOpen);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        setFilteredTargets(createPullRequestTargets ?? []);
    }, [
        createPullRequestTargets
    ]);
    const filterTargetsBySearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'searchTerm' implicitly has an 'any' type.
    (searchTerm)=>{
        setFilteredTargets(createPullRequestTargets ? createPullRequestTargets.filter((target)=>{
            const targetDisplayName = (0, $4W84M.getTargetDisplayName)(target);
            return (0, $lcCsd.default)(targetDisplayName, searchTerm);
        }) : []);
    }, [
        createPullRequestTargets
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (wasOpen !== isOpen) {
            isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'createPullRequestDropdown');
            !isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'createPullRequestDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        wasOpen,
        isOpen,
        onOpenDropdown
    ]);
    const CreatePullRequestTargets = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0d1a4c0cace8e3c$var$TargetsContainer, null, hasErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dMjRW.CreatePullRequestAuthenticationRow), {
            onClick: ()=>{
                onAuthErrorClick && onAuthErrorClick();
                setIsOpen(false);
            }
        }), filteredTargets.map((target, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4W84M.CreatePullRequestTargetRow), {
                key: `${index}-${target.createPullRequestUrl}`,
                createPullRequestTarget: target
            }))), [
        filteredTargets,
        hasErrors,
        onAuthErrorClick,
        setIsOpen
    ]);
    const DropDownWithTargetsContent = (0, $5uXOq.useMemo)(()=>{
        let targetsContent;
        if (createPullRequestTargets && createPullRequestTargets.length > 0 && filteredTargets.length === 0) targetsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hqPdr.NoResultsFound), null);
        else if (createPullRequestTargets && createPullRequestTargets.length >= 0) targetsContent = CreatePullRequestTargets;
        else targetsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EE6D.DevSummaryCreatePullRequestPopupSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
            xcss: $a0d1a4c0cace8e3c$var$dropDownWithTargetsContentWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0d1a4c0cace8e3c$var$SearchFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            onChange: (value)=>filterTargetsBySearch(value),
            onBlur: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'input blurred', 'createPullRequestListFilter');
            },
            placeholder: formatMessage((0, $dRg19.default).searchButtonPlaceholder),
            shouldFitContainerWidth: true,
            isAutocompleteDisabled: true,
            placeholderAlwaysVisible: true,
            searchIconVisible: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0d1a4c0cace8e3c$var$Hr, {
            role: "presentation"
        }), targetsContent);
    }, [
        createPullRequestTargets,
        filteredTargets,
        CreatePullRequestTargets,
        createAnalyticsEvent,
        filterTargetsBySearch,
        formatMessage
    ]);
    const DropDownContent = createPullRequestTargets && createPullRequestTargets.length === 0 && !hasErrors ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iWLt.NoEligibleBranches), null) : DropDownWithTargetsContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        id: "create-pull-request-dropdown",
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageType: "transactional",
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-end",
        shouldFlip: true,
        trigger: (triggerProps)=>renderDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                attributes: {
                    linkListLength: createPullRequestTargets ? createPullRequestTargets.length : 0,
                    filteredListLength: filteredTargets.length
                }
            }, DropDownContent)
    });
};
const $a0d1a4c0cace8e3c$var$CreatePullRequestDropdown = ({ renderDropdownTrigger: renderDropdownTrigger, createPullRequestTargets: createPullRequestTargets, onOpenDropdown: onOpenDropdown, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0d1a4c0cace8e3c$var$CreatePullRequestDropdownInner, {
        renderDropdownTrigger: renderDropdownTrigger,
        createPullRequestTargets: createPullRequestTargets,
        onOpenDropdown: onOpenDropdown,
        hasErrors: hasErrors,
        onAuthErrorClick: onAuthErrorClick
    });
var $a0d1a4c0cace8e3c$export$2e2bcd8739ae039 = $a0d1a4c0cace8e3c$var$CreatePullRequestDropdown;
const $a0d1a4c0cace8e3c$var$dropDownWithTargetsContentWrapperStyles = (0, $gDPDy.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0d1a4c0cace8e3c$var$SearchFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91feq _19pkidpf _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0d1a4c0cace8e3c$var$Hr = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _x3doudwz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0d1a4c0cace8e3c$var$TargetsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _c71l13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lcCsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdbe69dc2a26dc34$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cdbe69dc2a26dc34$export$2e2bcd8739ae039 = (haystack, needle)=>{
    if (!needle) return true;
    if (!haystack) return false;
    const haystackLowerCase = haystack.toLocaleLowerCase();
    const needleLowerCase = needle.toLocaleLowerCase();
    return haystackLowerCase.includes(needleLowerCase);
};

});

parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $12d8n = parcelRequire("12d8n");

var $4uPaz = parcelRequire("4uPaz");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? {
            reducedHeight: reducedHeight
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uPaz.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $4zsnF = parcelRequire("4zsnF");

var $1AG7G = parcelRequire("1AG7G");

var $gPt5r = parcelRequire("gPt5r");
var $95FmA = parcelRequire("95FmA");
var $gDPDy = parcelRequire("gDPDy");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zsnF.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1AG7G)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $gDPDy.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $95FmA.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $jgPn0 = parcelRequire("jgPn0");

var $3fgs9 = parcelRequire("3fgs9");

var $90b1k = parcelRequire("90b1k");

var $cF6qn = parcelRequire("cF6qn");

var $gPt5r = parcelRequire("gPt5r");
var $95FmA = parcelRequire("95FmA");
var $gDPDy = parcelRequire("gDPDy");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($90b1k))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgPn0.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fgs9))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cF6qn))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $gDPDy.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $gDPDy.xcss)({
    marginRight: 'space.075',
    [(0, $95FmA.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $gDPDy.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $95FmA.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $gDPDy.xcss)({
    marginLeft: 'space.075',
    [(0, $95FmA.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("5EE6D", function(module, exports) {

$parcel$export(module.exports, "DevSummaryCreatePullRequestPopupSkeleton", () => $fea6c780c6c21655$export$2bd52f77e389dbd7);
/* DevSummaryCreatePullRequestPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $iIru6 = parcelRequire("iIru6");
const $fea6c780c6c21655$var$containerStyles = null;
const $fea6c780c6c21655$export$2bd52f77e389dbd7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _4t3i1kei _1v7tn7od _1ieon7od _1vx6n7od _3glbn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iIru6)))
    }));

});
parcelRegister("iIru6", function(module, exports) {
module.exports = new URL("dev-summary-create-pull-request-popup.tpl.6a6b4b68.svg", import.meta.url).toString();

});


parcelRegister("dMjRW", function(module, exports) {

$parcel$export(module.exports, "CreatePullRequestAuthenticationRow", () => $e107a2a9eb6c4fc3$export$9fd100251e36a612);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ijGTm = parcelRequire("ijGTm");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $12d8n = parcelRequire("12d8n");

var $hHIHk = parcelRequire("hHIHk");
const $e107a2a9eb6c4fc3$export$9fd100251e36a612 = ({ onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e107a2a9eb6c4fc3$var$TargetRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "link",
        action: "viewed",
        actionSubjectId: "createPullRequestAuthenticationMessage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijGTm.default), {
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'createPullRequestAuthenticationMessage');
            onClick && onClick();
        },
        shouldTitleWrap: true,
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-authentication-row.button-item"
    }, formatMessage((0, $hHIHk.default).authenticationMessage), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e107a2a9eb6c4fc3$var$LinkFormatted, null, formatMessage((0, $hHIHk.default).openDialogPrompt))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e107a2a9eb6c4fc3$var$TargetRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1kdj _otyru2gc _i1wwu2gc _8ax3pxbi _ake1u2gc _1gqwpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e107a2a9eb6c4fc3$var$LinkFormatted = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz14q2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hHIHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaf9f0a2f3cdad38$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $eaf9f0a2f3cdad38$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    authenticationMessage: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-authentication-row.authentication-message",
        "defaultMessage": "We couldn't load all development information"
    },
    openDialogPrompt: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-authentication-row.open-dialog-prompt",
        "defaultMessage": "Find out more"
    }
});

});


parcelRegister("4W84M", function(module, exports) {

$parcel$export(module.exports, "getTargetDisplayName", () => $2917d334305bf58f$export$f9bb2ba84fb7a7cf);
$parcel$export(module.exports, "CreatePullRequestTargetRow", () => $2917d334305bf58f$export$46f8f5bb9e981547);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cZ9gG = parcelRequire("cZ9gG");

var $6SR3F = parcelRequire("6SR3F");

var $hu54A = parcelRequire("hu54A");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $12d8n = parcelRequire("12d8n");

var $iUVhR = parcelRequire("iUVhR");
const $2917d334305bf58f$export$f9bb2ba84fb7a7cf = (target)=>`${target.repositoryName}/${target.branchName}`;
const $2917d334305bf58f$export$46f8f5bb9e981547 = ({ createPullRequestTarget: createPullRequestTarget })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2917d334305bf58f$var$TargetRow, {
        key: createPullRequestTarget.createPullRequestUrl,
        "data-testid": "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.target-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hu54A.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2917d334305bf58f$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZ9gG.default // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        ), {
            src: createPullRequestTarget.repositoryAvatarUrl,
            appearance: "square",
            size: "xsmall"
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2917d334305bf58f$var$IconContainer, {
            "data-component-selector": "pull-request-icon-after"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6SR3F))), {
            label: formatMessage((0, $iUVhR.default).shortcutIconLabel),
            LEGACY_size: "small"
        })),
        href: createPullRequestTarget.createPullRequestUrl,
        target: "_blank",
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'createPullRequestLink', {
                scmProvider: createPullRequestTarget.scmProvider
            });
        },
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.link-item"
    }, $2917d334305bf58f$export$f9bb2ba84fb7a7cf(createPullRequestTarget))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2917d334305bf58f$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641mbg _tzy4idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2917d334305bf58f$var$TargetRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1kdj _ep9tidpf _9r1zpxbi _f5gaidpf _hstcpxbi _8udjkb7n _1v8xu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2917d334305bf58f$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUVhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6456cad3ca0f4405$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6456cad3ca0f4405$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shortcutIconLabel: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.shortcut-icon-label",
        "defaultMessage": "Open link in a new tab"
    }
});

});


parcelRegister("dRg19", function(module, exports) {

$parcel$export(module.exports, "default", () => $a303c73a887cf7f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a303c73a887cf7f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchButtonPlaceholder: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.search-button-placeholder",
        "defaultMessage": "Select branch to create pull request"
    }
});

});

parcelRegister("8iWLt", function(module, exports) {

$parcel$export(module.exports, "NoEligibleBranches", () => $af36581cf2ccaab8$export$9c262545a50dd8aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $eSmnQ = parcelRequire("eSmnQ");
const $af36581cf2ccaab8$export$9c262545a50dd8aa = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af36581cf2ccaab8$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "message",
        action: "viewed",
        actionSubjectId: "createPullRequestNoEligibleBranchesFoundMessage"
    }), formatMessage((0, $eSmnQ.default).noEligibleBranchesFound));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af36581cf2ccaab8$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12fnklw _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eSmnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $81271bec36440d46$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81271bec36440d46$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noEligibleBranchesFound: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.no-eligible-branches.no-eligible-branches-found",
        "defaultMessage": "We can't find any links to create a pull request. You'll need to create a pull request directly in your development tool."
    }
});

});


parcelRegister("hqPdr", function(module, exports) {

$parcel$export(module.exports, "NoResultsFound", () => $851989525db6df3d$export$c9765147a8dd7e5d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $6m6lI = parcelRequire("6m6lI");
const $851989525db6df3d$export$c9765147a8dd7e5d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($851989525db6df3d$var$MessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "message",
        action: "viewed",
        actionSubjectId: "createPullRequestNoSearchResultsFoundMessage"
    }), formatMessage((0, $6m6lI.default).noResultsFound));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851989525db6df3d$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6m6lI", function(module, exports) {

$parcel$export(module.exports, "default", () => $29be0f228d30a2da$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29be0f228d30a2da$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noResultsFound: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.no-results-found.no-results-found",
        "defaultMessage": "No matches found"
    }
});

});




//# sourceMappingURL=index-old.19d38386.js.map
